"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("components");
var styles = __importStar(require("./Fee.module.css"));
var Fee = (function (_super) {
    __extends(Fee, _super);
    function Fee(props) {
        return _super.call(this, props) || this;
    }
    Fee.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors, model = _a.model, _b = _a.fee, title = _b.title, identifier = _b.identifier, placeholder = _b.placeholder, description = _b.description;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees }, title),
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees },
                react_1.default.createElement(components_1.Input, { id: identifier, json_data: json_data, onChange: onChange, errors: errors, placeholder: placeholder, disabled: true })),
            react_1.default.createElement("td", { scope: "col", className: styles.alignFees }, description)));
    };
    return Fee;
}(react_1.Component));
exports.default = Fee;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmVlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9FbnJvbGxlbW50UGFja2V0SW5mb180XzYvcGFydHMvU2VjdGlvbjcvRmVlL0ZlZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUV0Qyx5Q0FBZ0M7QUFDaEMsdURBQTBDO0FBVTFDO0lBQWlDLHVCQUFvQjtJQUNqRCxhQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUVELG9CQUFNLEdBQU47UUFDVSxJQUFBLGVBTVEsRUFMVix3QkFBUyxFQUNULHNCQUFRLEVBQ1Isa0JBQU0sRUFDTixnQkFBSyxFQUNMLFdBQWtELEVBQTVDLGdCQUFLLEVBQUUsMEJBQVUsRUFBRSw0QkFBVyxFQUFFLDRCQUM1QixDQUFBO1FBRWQsT0FBTyxDQUNILDhCQUFDLGVBQUssQ0FBQyxRQUFRO1lBQ1gsc0NBQUksS0FBSyxFQUFDLEtBQUssRUFBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLFNBQVMsSUFDdEMsS0FBSyxDQUNMO1lBQ0wsc0NBQUksS0FBSyxFQUFDLEtBQUssRUFBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLFNBQVM7Z0JBQ3ZDLDhCQUFDLGtCQUFLLElBQ0YsRUFBRSxFQUFFLFVBQVUsRUFDZCxTQUFTLEVBQUUsU0FBUyxFQUNwQixRQUFRLEVBQUUsUUFBUSxFQUNsQixNQUFNLEVBQUUsTUFBTSxFQUNkLFdBQVcsRUFBRSxXQUFXLEVBQ3hCLFFBQVEsRUFBRSxJQUFJLEdBQ2hCLENBQ0Q7WUFDTCxzQ0FBSSxLQUFLLEVBQUMsS0FBSyxFQUFDLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FBUyxJQUN0QyxXQUFXLENBQ1gsQ0FDUSxDQUNwQixDQUFBO0lBQ0wsQ0FBQztJQUNMLFVBQUM7QUFBRCxDQUFDLEFBbkNELENBQWlDLGlCQUFTLEdBbUN6QyJ9